import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiUrls } from "constants/apiUrls";
import { baseQueryWithReAuth } from "utils/baseQueryWithReAuth";
import { AuthState } from "./types";

export const initialState: AuthState = {
    access_token: "",
    token_type: "",
    expires_in: 0,
    refresh_token: "",
    created_at: 0,
    user_id: "",
};

export const userAuthSlice = createSlice({
    name: "userAuth",
    initialState,
    reducers: {
        loginUser(state, { payload }: PayloadAction<AuthState>) {
            localStorage.setItem("userAuth", JSON.stringify({ ...payload }));
            state.access_token = payload.access_token;
            state.token_type = payload.token_type;
            state.expires_in = payload.expires_in;
            state.refresh_token = payload.refresh_token;
            state.created_at = payload.created_at;
            state.user_id = payload.user_id;
        },
        logoutUser(state) {
            localStorage.clear();
            state.access_token = initialState.access_token;
            state.token_type = initialState.token_type;
            state.expires_in = initialState.expires_in;
            state.refresh_token = initialState.refresh_token;
            state.created_at = initialState.created_at;
            state.user_id = initialState.user_id;
        },
    },
});

export const userAuthApiSlice = createApi({
    reducerPath: "userAuthApi",
    baseQuery: baseQueryWithReAuth,
    endpoints(builder) {
        return {
            login: builder.mutation({
                query: (postData) => ({
                    url: apiUrls.loginOrRefresh,
                    method: "POST",
                    body: JSON.stringify(postData),
                }),
            }),
            signUp: builder.mutation({
                query: (postData) => ({
                    url: apiUrls.signUp,
                    method: "POST",
                    body: JSON.stringify(postData),
                }),
            }),
            logout: builder.mutation({
                query: (token) => ({
                    url: apiUrls.logout,
                    method: "POST",
                    body: {
                        token,
                    },
                }),
            }),
            forgotPassword: builder.mutation({
                query: (email) => ({
                    url: apiUrls.forgotPassword,
                    method: "POST",
                    body: {
                        email,
                    },
                }),
            }),
            resetPassword: builder.mutation({
                query: (data) => ({
                    url: apiUrls.resetPassword,
                    method: "POST",
                    body: data,
                }),
            }),
        };
    },
});

export const {
    useLoginMutation,
    useSignUpMutation,
    useLogoutMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
} = userAuthApiSlice;
export const { loginUser, logoutUser } = userAuthSlice.actions;
export default userAuthSlice.reducer;
